/**
 * Shared "Privacy choices" opener — re-opens the CookieConsentBanner from
 * anywhere (footer link). Kept in its own module so both the banner (which
 * listens for the event) and the footer (which dispatches it) can share the
 * event name without the banner exporting non-component symbols.
 */
export const OPEN_PRIVACY_CHOICES_EVENT = 'hp:open-privacy-choices';

/** Re-open the consent banner (footer "Privacy choices" link). */
export function openPrivacyChoices(): void {
  try {
    window.dispatchEvent(new CustomEvent(OPEN_PRIVACY_CHOICES_EVENT));
  } catch {
    /* ignore */
  }
}
